import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box } from '@mui/material';
import './rich-text-editor.css';

interface RichTextEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    readOnly?: boolean;
    error?: boolean;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder = 'Digite o conteúdo...',
    readOnly = false,
    error = false
}) => {
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],        // Negrito, Itálico, Sublinhado
            [{ 'size': ['small', false, 'large', 'huge'] }], // Tamanhos de fonte
            ['link'],                                // Links
            ['clean']                                // Remover formatação
        ]
    };

    const formats = [
        'bold', 'italic', 'underline',
        'size',
        'link'
    ];

    return (
        <Box className={error ? 'rich-editor-container error' : 'rich-editor-container'}>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                readOnly={readOnly}
            />
        </Box>
    );
};
